import { orderInfoService } from "@/services/orderInfoService";

const HTTP_SCHEME = /^https?:\/\//i;

export function useDocumentLink() {
  async function openDocument(orderKey, storedLink) {
    if (!storedLink || !HTTP_SCHEME.test(storedLink)) return;
    if (!orderKey) {
      window.open(storedLink, "_blank", "noopener");
      return;
    }
    const win = window.open("", "_blank");
    try {
      const { url } = await orderInfoService.getFreshDocumentLink(orderKey, storedLink);
      if (win) win.location.replace(url);
      else window.open(url, "_blank", "noopener");
    } catch {
      if (win) win.location.replace(storedLink);
      else window.open(storedLink, "_blank", "noopener");
    }
  }

  return { openDocument };
}
